import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { request, gql } from 'graphql-request';
import PageHeader from '../components/PageHeader';
import { hyGraphToken, endpointURL } from "../ThemeModule";
import BlogArticle from "./blog/BlogArticle";
import Sidebar from "./blog/Sidebar";
import Seo from "../components/Seo";

const CategoryPosts = () => {
  const { category } = useParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const query = gql`
        query CategoryPosts($category: String) {
          postsConnection(where: {categories_some: {slug: $category}}) {
            edges {
              node {
                categories {
                  title
                  slug
                }
                title
                slug
                publishedAt
                featuredPost
                featureImage {
                  url
                }
              }
            }
          }
        }
      `;
      const variables = { category };
      const headers = {
        Authorization: `Bearer ${hyGraphToken}`
      };

      try {
        const data = await request(endpointURL, query, variables, headers);
        setPosts(data.postsConnection.edges);
      } catch (error) {
        console.error('Error fetching posts:', error);
        setError(error.message);
      } finally {
        setLoading(false); 
      }
    };
    fetchPosts();
  }, [category]);

  
  return (
    <>
      <Seo
        path={`/category/${category}`}
        title={`${category.replace(/-/g, " ")} articles`}
        description={`Dark Defensive articles on ${category.replace(/-/g, " ")} — cyber risk management, GRC automation, and compliance guidance.`}
      />

      <PageHeader title={`Category: ${category}`} />
      <section className="blog page-section relative shape-1 shape-2">
        <div className="max-w-container mx-auto px-4">
          <div className="mx-auto flex justify-left lg:px-5 lg:-mx-4">
            <div className="w-full lg:w-8/12 px-6">
              {loading ? (
                <div className="loader">Loading...</div>
              ) : error ? (
                <div className="error-message">
                  <p>Failed to load posts: {error}</p>
                </div>
              ) : (
                <div className="postGrid_box">
                  {posts.map(({ node }) => (
                    <BlogArticle key={node.slug} node={node} />
                  ))}
                </div>
              )}
            </div>

            <div className="w-full lg:w-4/12 px-6">
              <Sidebar  />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoryPosts;
